/*============================================================
   REDUX DEPENDENCIES
============================================================*/
import { useSelector, useDispatch } from "react-redux";

import Grid from "@mui/material/Grid2";
import Typography from "@mui/material/Typography";

import GridSectionHeader from "../../../widgets/GridSectionHeader";

//DATA SLICE - REDUCER
import { updateCKACKR } from "../../../../states/slcCkaCkr.js";

export default function SectionCKAOutcome() {
  const dispatch = useDispatch();

  //LOAD DATA FROM GLOBAL DATA MANAGER
  const isEducationQualified = useSelector(
    (state) => state.ckackr.isEducationQualified
  );
  const isFinanceQualified = useSelector(
    (state) => state.ckackr.isFinanceQualified
  );

  const isExperiencedInvestor = useSelector(
    (state) => state.ckackr.isExperiencedInvestor
  );
  const investedProducts = useSelector(
    (state) => state.ckackr.investedProducts
  );

  const isWorkExperienced = useSelector(
    (state) => state.ckackr.isWorkExperienced
  );

  var result = {
    isCkaPass: true,
    isCarPass: true,
  };

  calculateCkaCkrResult();

  function calculateCkaCkrResult() {
    if (
      isEducationQualified === "NO" &&
      isFinanceQualified === "NO" &&
      isExperiencedInvestor === "NO" &&
      isWorkExperienced === "NO"
    ) {
      result.isCkaPass = false;
      result.isCarPass = false;

      updateRedux("result", result, updateCKACKR);
      return;
    }

    //Check Investment Experiece
    if (
      isExperiencedInvestor === "YES" &&
      investedProducts[0] === "UNLISTED" &&
      investedProducts[1] === "LISTED"
    ) {
      result.isCkaPass = true;
      result.isCarPass = true;
      updateRedux("result", result, updateCKACKR);
      return;
    }

    //Check Investment Experiece & CKA --> CKR result
    if (isExperiencedInvestor === "YES" && investedProducts[0] === "UNLISTED")
      result.isCarPass = false;

    //Check Investment Experiece & CKR --> CKA result
    if (isExperiencedInvestor === "YES" && investedProducts[1] === "LISTED")
      result.isCkaPass = false;

    updateRedux("result", result, updateCKACKR);
  }

  function updateRedux(fieldName, fieldValue, reducer) {
    const action = {
      type: fieldName,
      payload: fieldValue,
    };
    dispatch(reducer(action));
  }

  return (
    <>
      <Grid container spacing={2}>
        <GridSectionHeader
          sectionName="Outcome of CKA/CAR"
          sx={{
            p: 1,
            pl: 1.8,
            mt: 0,
            mb: 1,
            fontSize: 18,
            fontWeight: "bold",
            color: "#FFFFFF", //WHITE
            // color: "#000000", //BLACK
            // backgroundColor: "#d9d9d9",
            backgroundColor: "#10B981",
          }}
        />

        {/*==============================
            CKA/CAR ASSESSMENT RESULT
        ==============================*/}
        <Typography variant="body1" sx={{ fontWeight: "bold" }}>
          ASSESSMENT OUTCOME: <br />
          a. Customer Knowledge Assessment(CKA) -{" "}
          {result.isCkaPass ? "Passed" : "Falied"} <br />
          b. Customer Accounts Review(CAR) -{" "}
          {result.isCarPass ? "Passed" : "Falied"} <br />
        </Typography>

        {(result.isCkaPass || result.isCarPass) && (
          <Typography variant="body2">
            You are assessed: To have acquired the relevant knowledge and/or
            experience to understand and purchase the relevant "Specified
            Investment Products"
          </Typography>
        )}

        <Typography
          variant="h6"
          gutterBottom
          sx={{ p: 2, my: 1, border: "1px solid", borderRadius: 5 }}
        >
          Note:
          <Typography variant="body1">
            In the event of a joint investment, both clients will be deemed to
            have fulfilled the criteria in the CKA/CAR if one of them is
            assessed not to have possessed the knowledge or experience in a
            Specified Investment Product
          </Typography>
          <br />
          <Typography variant="body1">
            The personal inforamation gathered here by the adviser, including
            the statement(s) and other documents provided by you, is for the
            purpose of providing you, the client, with suitable financial
            recommendation and will be kept confidential.
          </Typography>
        </Typography>

        {/*==============================
            ACKNOWLEDGE CKA/CAR OUTCOME
        ==============================*/}
        <Typography
          variant="h6"
          gutterBottom
          sx={{ p: 2, my: 1, border: "1px solid", borderRadius: 5 }}
        >
          Client Acknowledgement of CKA & CAR Outcome
          <Typography variant="body1">
            <ul>
              <li>
                I have been given a clear explanation of the objectives for the
                Customer Knowledge Assessment / Customer Account Review
              </li>

              <li>
                I have answered all the relevant questoins to the best of my
                knowledge.
              </li>

              <li>
                I understand and agree with the outcome of the Customer
                Knowledge Assessment / Customer Account Review
              </li>

              <li>
                I have provided the correct infdormation as above and understand
                that my inaccurate or incomplete information provided by me may
                affect the coutcome of the CKA/CAR
              </li>
            </ul>
          </Typography>
        </Typography>
      </Grid>
    </>
  );
}
